import React, {Fragment} from "react";
import PropTypes from "prop-types";
import Page from "../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import DashboardOrdiniEcommerce from "./DashboardOrdiniEcommerce";

export class DashboardOrdiniEcommercePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <Fragment>
                <Page
                    title={"Ordini"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    
                    onLeftIconClick={this.props.onDismiss}
                    active={true}
                >
                    <DashboardOrdiniEcommerce {...this.props.userNegozio}/>
                </Page>
            </Fragment>
        )
    }

}

DashboardOrdiniEcommercePage.propTypes = {
    userNegozio: PropTypes.object,
    onDismiss: PropTypes.func,
}